import firebase from "config/firebase";

export const createSportRequest = (obj) => async (dispatch) => {
  const docRef = await firebase
    .firestore()
    .collection("requested_sports")
    .add(obj);
  const notificationData = {
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    type: "sport",
    notifyID: docRef.id,
    status: false
  };
  await firebase
    .firestore()
    .collection("admin_notifiaction")
    .add(notificationData);
};

export const getSportRequest =
  (lastDocument, onSuccess) => async (dispatch) => {
    let querya = firebase.firestore().collection("requested_sports");
    if (lastDocument) {
      querya = querya.startAfter(lastDocument);
    }
    querya = querya.limit(5);
    return querya.onSnapshot((snapshot) => {
      let temp_data = [];
      snapshot.forEach((doc) => {
        temp_data.push({
          id: doc.id,
          ...doc.data()
        });
      });
      dispatch({
        type: lastDocument ? "GET_SPORT_REQUEST_MORE" : "GET_SPORT_REQUEST",
        payload: {
          data: temp_data,
          lastDocument: snapshot.docs[temp_data.length - 1] || null,
          hasMoreDocument: temp_data.length >= 5
        }
      });

      if (onSuccess) onSuccess();
    });
  };

export const updateSportRequest = (id, data) => {
  return async (dispatch) => {
    await firebase.firestore().collection("requested_sports").doc(id).update({
      supported_by: data,
      support: data.length
    });
  };
};
